module.exports = __webpack_public_path__ + "assets/img/notepad.761c09d6.svg";